module.exports = __webpack_public_path__ + "static/media/know-display-ui.78a0eb41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/awair/know-display-ui.png
// module id = 238
// module chunks = 0